<template>
  <div class="hbn-container" id="userInfo">
  <el-tabs
    v-model="activeName"
    type="card"
    class="demo-tabs"
    @tab-click="handleClick"
  >
    <el-tab-pane label="系统参数" name="first">
      <el-form-item class="my-form-item">
            <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
      <el-form :model="form" label-width="120px">
        <el-row
          v-for="(item, index) in DataList"
          :key="index"
          style="margin-bottom: 20px"
        >
          <el-col :span="24">
            <el-form-item :label="item.title" v-if="item.key=='IsShowReportSubTitle'" prop="IsShowReportSubTitle">
                <el-radio-group v-model="item.value">
                    <el-radio label="0" size="large">不展示</el-radio>
                    <el-radio label="1" size="large">展示</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="item.title" v-if="item.key=='WhetherRegistrationRequiresApproval'" prop="WhetherRegistrationRequiresApproval">
                <el-radio-group v-model="item.value">
                    <el-radio label="0" size="large">全部需审批</el-radio>
                    <el-radio label="1" size="large">全部无需审批</el-radio>
                </el-radio-group>
            </el-form-item>
             <el-form-item :label="item.title" v-if="item.key=='EnableCapture'" prop="EnableCapture">
                <el-radio-group v-model="item.value">
                    <el-radio label="1" size="large">开启</el-radio>
                    <el-radio label="0" size="large">禁用</el-radio>
                    <el-radio label="2" size="large">严格抓拍</el-radio>
                </el-radio-group>
                <span>启用人脸识别后,系统注册将必填身份证信息,课程学习时将开启抓拍</span>
            </el-form-item>
            <el-form-item :label="item.title" v-if="item.key=='EnableCourseCapture'" prop="EnableCourseCapture">
                <el-radio-group v-model="item.value">
                    <el-radio label="0" size="large">按章节抓拍</el-radio>
                    <el-radio label="1" size="large">按课程抓拍</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="item.title" v-if="item.key=='Threshold'" prop="Threshold">
              <el-select v-model="item.value" :disabled="getEnableValue()">
                <el-option key="1" label="60" value="60" />
                <el-option key="2" label="70" value="70" />
                <el-option key="3" label="78" value="78" />
                <el-option key="4" label="80" value="80" />
              </el-select>
            </el-form-item>
            <el-form-item :label="item.title+':课程学习第'" v-if="item.key=='CaptureTimePoint'" prop="CaptureTimePoint">
                <el-input-number size="small" style="width:150px;" v-model="item.value" :min="0" :step="1" controls-position="right" step-strictly></el-input-number>
                分钟一次
            </el-form-item>
            <el-form-item :label="item.title" v-if="item.key=='AgreementContent'" prop="AgreementContent" style="height:580px;">
                   <MyCkdeitor
                        @sendContnet="getContent"
                        :content="item.value"
                   ></MyCkdeitor>
              </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-tab-pane>
    <!-- <el-tab-pane label="Config" name="second">Config</el-tab-pane>
    <el-tab-pane label="Role" name="third">Role</el-tab-pane>
    <el-tab-pane label="Task" name="fourth">Task</el-tab-pane> -->
  </el-tabs>
  </div>
</template>

<script>

import { GetDataSystemConfigList,ModifyAllSystemConfig } from "@api/ApiSystemConfig";
import { setSystemConfig,ClearSystemConfig } from "@/util/authority";
import MyCkdeitor from "@/components/RichText/MyCkdeitor.vue"

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
          sortField: {
            OrderNumber: "ASC",
          },
        },
        pageindex: 1,
        PageSize: 1000,
      },
      total:0,
      DataList: [],
      activeName : "first"
    };
  },
  components: {
      MyCkdeitor
  },
  computed: {

  },
  methods: {
    handleClick () {

    },
    getEnableValue() {
      let disabledValue = true;
      let item = this.DataList.find(ss => {
        return ss.key == "EnableCapture"
      })
      if(item && item.value == "2") {
        disabledValue = false;
      }
      return disabledValue;
    },
    GetData() {
      const _this = this;
      try {
        GetDataSystemConfigList(_this.PageQuery).then(function (
          data
        ) {
          data.entities.forEach(item => {
            if(item.key === 'CaptureTimePoint' && item.value) {
              item.value = Number(item.value)
            } 
          });
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    //获取富文本编译器内容
    getContent(val) {
      const index = this.DataList.findIndex(item=>item.key === 'AgreementContent');
      if(index != -1) {
        this.DataList[index].value = val;
      }
    },
    onSubmit:function(){
        var _this = this
        ModifyAllSystemConfig(_this.DataList).then(data=>{
            if(data.code==200){
                this.$message.success("保存成功!");
                ClearSystemConfig(); //先清空
                setSystemConfig(_this.DataList);//在保存
            }else{
                this.$message.error(data.message);
            }
        });
    },

  },
  created() {
    this.GetData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
</style>
<style lang="scss" scoped>
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
.hbn-container ::v-deep .el-form-item .el-form-item__label {
  width: 150px !important;
}
.hbn-container ::v-deep .el-radio {
  min-width: 90px;
}
.hbn-container ::v-deep .el-radio__label {
  font-size: 12px;
}
.my-form-item {
  position: fixed;
  right: 30px;
  z-index: 999;
}
</style>